import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import ModalComponent from '../../../../core/components/modal/ModalComponent';
import { useModal } from '../../../../hooks/useModal';
import { PAYMENT_MODAL_NAME } from '../../../../constants/modalNamesConstants';
import ButtonComponent, { ButtonSizeEnum } from '../../../../core/components/button/ButtonComponent';
import {
  useCheckPayStatusCryptoFont, usePayCryptoFont, usePayFont, useUpdateFont, useGetFonts
} from '../font/useFonts';
import { AppStateTypes } from '../../../../store/appStateTypes';
import { socket } from '../../../../helpers/socket';

const PaymentModalContainer: FC = () => {
  const { onCloseModal, payload } = useModal(PAYMENT_MODAL_NAME);

  const fontCreator = useSelector((state: AppStateTypes) => state.fontCreator);

  const { fontId } = payload;

  const currentFont = fontCreator.find((font) => Number(font.fontId) === Number(fontId));

  const { isLoadingUpdateFont, updateFont } = useUpdateFont();
  const { isLoadingPayFont, payFont } = usePayFont();
  const { isLoadingPayCryptoFont, payCryptoFont } = usePayCryptoFont();
  const { isCheckPayStatusCryptoFont, checkPayStatusCryptoFont } = useCheckPayStatusCryptoFont();
  const { loadingFonts } = useGetFonts();

  const buttonProps = {
    text: 'Купить шрифт за 99₽',
    onClick: async () => {
      const { paymentConfirmationToken, status, paymentId } = await payFont(fontId) || {};

      if (paymentConfirmationToken && paymentId) {
        // Подписываемся на WebSocket событие о покупке шрифта
        const handlePaymentSuccess = async () => {
          await loadingFonts();
          onCloseModal();
          socket.off(`payment:${paymentId}`, handlePaymentSuccess);
        };

        socket.on(`payment:${paymentId}`, handlePaymentSuccess);

        // @ts-ignore
        const checkout = new window.YooMoneyCheckoutWidget({
          confirmation_token: paymentConfirmationToken,
          customization: {
            modal: true
          },
          error_callback() {
            // Обработка ошибок инициализации
          }
        });

        checkout.render();

        checkout.on('success', () => {
          // Платеж прошел, ждем события от webhook через WebSocket
          checkout.destroy();
          // Событие handlePaymentSuccess сработает когда webhook обработает платеж
        });

        checkout.on('fail', () => {
          // Платеж не прошел, отписываемся от события
          socket.off(`payment:${paymentId}`, handlePaymentSuccess);
          checkout.destroy();
        });
      }

      if (status === 'succeeded') {
        // Платеж уже успешен, webhook обновит шрифт
        await loadingFonts();
        onCloseModal();
      }
    },
    isLoading: isLoadingPayFont || isLoadingUpdateFont
  };

  const buttonPropsCrypto = {
    text: 'Купить шрифт за $2.59',
    onClick: async () => {
      if (currentFont?.orderId) {
        const { statusInvoice } = await checkPayStatusCryptoFont(currentFont?.orderId) || {};

        if (statusInvoice === 'created') {
          window.location.href = `https://pay.cryptocloud.plus/${currentFont?.orderId}`;
        }
      } else {
        const { status, payUrl, invoiceId } = await payCryptoFont(fontId) || {};

        if (status === 'success') {
          await updateFont({
            fontId,
            orderId: invoiceId,
          });

          if (payUrl) {
            window.location.href = payUrl;
          }
        }
      }
    },
    isLoading: isLoadingPayCryptoFont || isCheckPayStatusCryptoFont
  };

  return (
        <ModalComponent title="Купить шрифт" onClose={onCloseModal}>
            <div className="flex items-center justify-center -m-16">
              <div className="p-16 w-6/12 border-r border-solid border-gray">
                <div className="font-semibold mb-8">Оплата шрифта с карты российского банка:</div>
                <ButtonComponent {...buttonProps} size={ButtonSizeEnum.SM} />
              </div>
              <div className="p-16 w-6/12">
                <div className="font-semibold mb-8">Оплата шрифта с помощью криптовалюты:</div>
                <ButtonComponent {...buttonPropsCrypto} size={ButtonSizeEnum.SM} />
              </div>
            </div>
        </ModalComponent>
  );
};

export default PaymentModalContainer;
